import TopNav from './TopNav.vue';

TopNav.install = function (Vue) {
  Vue.component(TopNav.name, TopNav);
};

export default TopNav;